module.exports = __webpack_public_path__ + "img/casebg3.44cfe501.png";